module.exports = __webpack_public_path__ + "static/media/Ramona Avenue, Albany, CA3.92c4f9f1.jpg";